



































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapMutations } from "vuex";
import XButton from "../SimpleButton.vue";
import moment from "moment";

@Component({
  components: { XButton },
  methods: {
    ...mapMutations("error", { setShow: "setShow", setMessage: "setMessage" }),
  },
})
class Alert extends Vue {
  @Prop({ required: true }) readonly type!: string;
  @Prop({ required: true }) readonly title!: string;
  @Prop({ required: true }) readonly message!: string;

  @Prop({ default: false }) readonly show!: boolean;

  get getDateTime() {
    return moment().format("DD.MM.YYYY HH:mm");
  }
}

export default Alert;
